import type { CSSObject } from 'tss-react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ breakpoints, mixins, spacing }: Theme) => ({
  toolbar: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'normal',
    width: '100%',
    marginTop: spacing(2.5),
    marginBottom: 0,
    padding: spacing(1.5, 5),
    [breakpoints.up('sm')]: {
      // necessary for content to be below app bar
      ...(mixins.toolbar as CSSObject),
      padding: spacing(5, 4.5),
      marginTop: spacing(3),
    },
    [breakpoints.between('sm', 'lg')]: {
      justifyContent: 'center',
    },
  },
  image: {
    minWidth: 64,
    [breakpoints.up('lg')]: {
      display: 'inline-flex',
      flexShrink: 0,
    },
  },
  wordLogo: {
    [breakpoints.between('sm', 'lg')]: {
      display: 'none',
    },
  },
  chip: {
    fontWeight: 'bold',
    margin: spacing('auto', 4.75),
    [breakpoints.up('lg')]: {
      transform: 'none',
      bottom: 0,
      margin: spacing('auto', 1, 'auto', 2),
    },
    [breakpoints.down('lg')]: {
      margin: spacing(0, 0, 2, 0),
    },
    [breakpoints.between('sm', 'lg')]: {
      position: 'absolute',
      bottom: 0,
      left: spacing(7),
      transform: 'rotate(-35deg)',
    },
  },
  logoFound: {
    height: 64,
  },
}));
